<template>
  <div style="
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;">
    <transition name="fade">
      <router-view class="wrapper"></router-view>
    </transition>

    <!-- 锁定屏幕对话框 -->
    <el-dialog
      title="系统已锁定"
      :visible.sync="isLocked"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <el-form :model="loginForm" ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="unlock">解锁</el-button>
      </div>
    </el-dialog>

    <!-- 密码更新对话框 -->
    <el-dialog
      title="密码已过期"
      :visible.sync="showPasswordUpdate"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <div class="current-user-info">
        当前用户：{{ currentUsername }}
      </div>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
        <el-form-item prop="pass" label="原密码">
          <el-input v-model="passwordForm.pass" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="newpass" label="新密码">
          <el-input v-model="passwordForm.newpass" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="checknewPass" label="确认密码">
          <el-input v-model="passwordForm.checknewPass" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="updatePassword">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crypto from './libraries/utils/crypto.js'  // 添加加密模块导入

export default {
  name: 'app',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newpass) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    const validatePassword = (rule, value, callback) => {
      if (this.$GlobalConfig.security.enableComplexPassword) {
        // 启用复杂密码规则时的验证
        if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value)) {
          callback(new Error('密码必须至少8位且包含数字、大小写字母及特殊字符'))
        } else {
          callback()
        }
      } else {
        // 不启用复杂密码规则时，只验证非空
        if (!value) {
          callback(new Error('请输入新密码'))
        } else {
          callback()
        }
      }
    }

    return {
      isLocked: false,  // 默认值改为 false
      timer: null,
      timeout: this.$GlobalConfig.security.screenLockTimeout,  // 使用配置的超时时间
      lastActivity: localStorage.getItem('lastActivity') || new Date().getTime(),
      loginForm: {
        username: '',
        password: ''
      },
      // 新增密码更新相关数据
      showPasswordUpdate: false,
      passwordForm: {
        pass: '',
        newpass: '',
        checknewPass: ''
      },
      passwordRules: {
        pass: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newpass: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        checknewPass: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      currentUsername: ''  // 添加当前用户名变量
    }
  },
  created() {
    // 只有在启用屏幕锁定时才添加事件监听和启动定时器
    if (this.$GlobalConfig.security.enableScreenLock) {
      this.isLocked = localStorage.getItem('isLocked') === 'true'
      this.addActivityListeners()
      this.startTimer()
    }

    // 只有在启用密码过期检查且未锁定的情况下才检查密码过期
    if (this.$GlobalConfig.security.enablePasswordExpiry &&
        !this.isLocked &&
        this.$store.state.session.token) {
      this.checkPasswordExpiration()
    }
  },
  beforeDestroy() {
    // 清理事件监听和定时器
    this.removeActivityListeners()
    this.clearTimer()
  },
  methods: {
    addActivityListeners() {
      // 监听用户活动
      ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
        document.addEventListener(event, this.resetTimer)
      })
    },
    removeActivityListeners() {
      ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
        document.removeEventListener(event, this.resetTimer)
      })
    },
    startTimer() {
      this.timer = setInterval(() => {
        // 如果在登录页面或未登录，不进行锁定检查
        if (this.$route.name === 'login' || !this.$store.state.session.token) {
          this.isLocked = false
          localStorage.setItem('isLocked', 'false')
          return
        }

        const now = new Date().getTime()
        const lastActivity = parseInt(localStorage.getItem('lastActivity') || now)
        // 检查是否超时
        if (now - lastActivity >= this.timeout) {
          this.lock()
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    resetTimer() {
      const now = new Date().getTime()
      this.lastActivity = now
      localStorage.setItem('lastActivity', now)
    },
    lock() {
      // 如果未启用屏幕锁定，直接返回
      if (!this.$GlobalConfig.security.enableScreenLock) {
        return
      }

      // 如果在登录页面、已经锁定或未登录，则不执行锁定操作
      if (this.$route.name === 'login' ||
          this.isLocked ||
          !this.$store.state.session.token) {
        return
      }

      this.isLocked = true
      localStorage.setItem('isLocked', 'true')
      this.loginForm.username = ''
      this.loginForm.password = ''
    },
    async unlock() {
      try {
        // 对登录信息进行加密
        const loginData = {
          username: crypto.encrypt(this.loginForm.username),
          password: crypto.encrypt(this.loginForm.password)
        }
        // 使用加密后的数据进行验证
        await this.$store.dispatch('createToken', loginData)
        await this.$store.dispatch('getCurrentUser')
        // 解锁成功后检查密码是否过期
        await this.checkPasswordExpiration()
        this.isLocked = false
        localStorage.setItem('isLocked', 'false')
        this.resetTimer()
        this.$message.success('解锁成功')
      } catch (error) {
        this.$message.error('解锁失败，请重试')
      }
    },
    async checkPasswordExpiration() {
      try {
        // 如果未启用密码过期检查，直接返回
        if (!this.$GlobalConfig.security.enablePasswordExpiry) {
          this.showPasswordUpdate = false
          return
        }

        // 严格检查当前状态
        if (!this.$store.state.session.token ||
            this.$route.name === 'login' ||
            this.isLocked) {
          this.showPasswordUpdate = false
          return
        }

        const userInfo = await this.$store.dispatch('getCurrentUser')
        // 确保用户信息和密码修改日期存在
        if (!userInfo.Profile.Changepassworddate) {
          return
        }
        // 设置当前用户名
        this.currentUsername = userInfo.Profile.Realname || '未知用户'

        const lastPasswordUpdate = new Date(userInfo.Profile.Changepassworddate)
        const now = new Date()
        const expiryTime = this.$GlobalConfig.security.passwordExpiryDays * 24 * 60 * 60 * 1000

        this.showPasswordUpdate = (now - lastPasswordUpdate > expiryTime)
      } catch (error) {
        console.error('检查密码过期失败:', error)
        this.showPasswordUpdate = false
      }
    },
    async updatePassword() {
      try {
        await this.$refs.passwordForm.validate()
        // 对密码信息进行加密
        const encryptedPasswordData = {
          pass: crypto.encrypt(this.passwordForm.pass),
          newpass: crypto.encrypt(this.passwordForm.newpass),
          checknewPass: crypto.encrypt(this.passwordForm.checknewPass)
        }
        await this.$services.user.put('userchangepwd', encryptedPasswordData)
        .then(res => {
          if (res.data.code === 0) {
            this.showPasswordUpdate = false
            this.passwordForm = {
              pass: '',
              newpass: '',
              checknewPass: ''
            }
            this.$message.success('密码更新成功')
          } else {
            this.$message.error('密码更新失败，请重试')
          }
        })
      } catch (error) {
        this.$message.error('密码更新失败，请重试')
      }
    }
  },
  watch: {
    // 优化路由监听
    '$route': {
      handler(newRoute, oldRoute) {
        // 进入登录页面时关闭密码修改弹窗
        if (newRoute.name === 'login') {
          this.showPasswordUpdate = false
          this.isLocked = false
          localStorage.setItem('isLocked', 'false')
        }

        // 处理页面切换时的定时器清理
        if (oldRoute) {
          switch (oldRoute.name) {
            case 'dashboard':
              Window.indexinterval && clearInterval(Window.indexinterval)
              break
            case 'equipment':
              Window.equimentinterval && clearInterval(Window.equimentinterval)
              break
            case 'alerts':
              Window.alerterinterval && clearInterval(Window.alerterinterval)
              break
            case 'management':
              Window.managementinterval && clearInterval(Window.managementinterval)
              break
          }
        }
      },
      immediate: true,
      deep: true
    },

    // 优化登录状态监听
    '$store.state.session.token': {
      handler(newToken) {
        if (newToken && this.$route.name !== 'login') {
          // 添加延时确保用户信息已加载
          setTimeout(() => {
            this.checkPasswordExpiration()
          }, 1000)
        } else {
          this.showPasswordUpdate = false
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
.el-dialog {
  width: 400px;
}
.current-user-info {
  margin-bottom: 20px;
  color: #606266;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// App.vue?4a799588